var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMappin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83158 0.00127188C4.5364 -0.0237853 3.27105 0.391474 2.24257 1.1791C1.21409 1.96673 0.483356 3.08011 0.169951 4.33705C-0.143455 5.594 -0.0209772 6.92009 0.517323 8.09838C1.05562 9.27667 1.97788 10.2374 3.13321 10.8233C3.58177 11.0714 4.06334 11.2544 4.56343 11.3668V18.8326C4.59103 19.1512 4.73709 19.4478 4.97276 19.6639C5.20842 19.8801 5.51656 20 5.83633 20C6.1561 20 6.46426 19.8801 6.69993 19.6639C6.93559 19.4478 7.08165 19.1512 7.10925 18.8326V11.3668C7.60935 11.2544 8.09091 11.0714 8.53948 10.8233C9.69565 10.2371 10.6184 9.27553 11.1566 8.09623C11.6949 6.91693 11.8166 5.5898 11.502 4.33225C11.1873 3.07471 10.4549 1.96129 9.42467 1.17445C8.39447 0.387598 7.12761 -0.0260527 5.83158 0.00127188ZM5.83158 9.53612C5.07726 9.53612 4.33986 9.31245 3.71267 8.89337C3.08547 8.47429 2.59663 7.87861 2.30796 7.18171C2.01929 6.4848 1.94375 5.71794 2.09092 4.97811C2.23808 4.23828 2.60133 3.5587 3.13472 3.02531C3.66811 2.49193 4.34769 2.1287 5.08752 1.98154C5.82735 1.83438 6.59421 1.90991 7.29111 2.19858C7.98802 2.48725 8.58366 2.97609 9.00275 3.60329C9.42183 4.23049 9.64552 4.96785 9.64552 5.72218C9.64552 6.7337 9.24367 7.70379 8.52842 8.41904C7.81317 9.13429 6.8431 9.53612 5.83158 9.53612Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMappin);
export default __webpack_public_path__ + "static/media/info-mappin.8daa3a78d61b1f6eb325a437a215569c.svg";
export { ForwardRef as ReactComponent };